import { useFetch } from '@chipinside/fetcher'
import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import isEmpty from 'lodash/isEmpty'
import React, { useState } from 'react'

import { DatasheetContent } from '#/components/Datasheets/Animal/content'
import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

const AnimalStatus = ({ route = '' }) => {
  const [open, setOpen] = useState(false)
  const { data, error, isLoading } = useFetch({
    controller: open && route ? route : null,
  })

  return (
    <>
      <Box
        sx={{
          margin: 1,
          position: 'relative',
        }}
      >
        <IconButton aria-label="info" onClick={() => setOpen(true)} size="large">
          <Box sx={{ position: 'relative' }}>
            <Icon
              size="large"
              name="memory"
              sx={{
                position: 'absolute',
                right: '-8px',
                top: '-14px',
                transform: 'scale(-1, 1)',
              }}
            />
            <Icon
              size="large"
              name="mui-info"
              color={!isLoading ? 'primary' : error ? 'error' : 'secondary'}
              sx={{
                position: 'absolute',
                top: '-8px',
              }}
            />
          </Box>
        </IconButton>
        {isLoading && (
          <CircularProgress
            size={25}
            color="primary"
            sx={{
              position: 'absolute',
              top: 12,
              left: 12,
              zIndex: 1,
            }}
          />
        )}
      </Box>
      {open && !isLoading ? (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullWidth
          maxWidth="xs"
          slotProps={{
            paper: {
              style: { backgroundColor: Colors.darkerGray, padding: 20 },
            },
          }}
        >
          {!isEmpty(data) ? <DatasheetContent AnimalData={data} Loading={isLoading} /> : null}
        </Dialog>
      ) : null}
    </>
  )
}

export default AnimalStatus
